import React from 'react';
import cx from 'classnames';
import withStyles from '@mui/styles/withStyles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '../icon/CloseIcon';

/**
 * tag button used for filtering. can be 'removed'
 */
function TagButton(props) {
    const { classes, onClickRemove, text, className } = props;

    return (
        <span color="primary" className={cx(classes.root, className)}>
                <span className={classes.text}>{text}</span>
            {onClickRemove && (
                <IconButton onClick={onClickRemove} className={classes.icon} title="Remove" size="large">
                    <CloseIcon />
                </IconButton>
            )}
            </span>
    );
}

const styles = ({ palette }) => ({
    root: {
        backgroundColor: palette.action.active,
        borderRadius: '8px',
        color: '#FFFFFF',
        padding: '0 6px',
        display: 'inline-flex',
        fontSize: '0.875rem',
        minHeight: '1.5rem',
        alignItems: 'center'
    },
    text: {
        whiteSpace: 'nowrap'
    },
    icon: {
        height: '20px',
        width: '20px',
        marginLeft: '8px',
        '& > span:first-child': {
            border: '1px solid #FFFFFF',
            width: 'unset',
            borderRadius: '50%',
            padding: '2px',
            '&:hover': {
                background: palette.action.destroy
            },
            '& > svg': {
                height: '12px',
                width: '12px',
                color: '#FFFFFF'
            }
        }
    }
});

export default withStyles(styles)(TagButton);
